import { useNavigate } from "react-router-dom";
import { usePermissionValidator } from "../api/UserPermissionValidators";
import PageHeader from "../shared-components/PageHeader";
import WorkflowRoles from "./WorkflowRoles";

import WorkflowsDashboard from "./WorkflowsDashboard";
import Container from "../shared-components/Container";

const Workflows = () => {
  const { canManageWorkflows, canManageAnalystRoles } =
    usePermissionValidator();
  const navigate = useNavigate();
  if (!canManageWorkflows) navigate("/");

  return (
    <Container>
      <PageHeader title={"Workflow"}></PageHeader>

      <WorkflowsDashboard />

      {canManageAnalystRoles && <WorkflowRoles />}
    </Container>
  );
};

export default Workflows;
